export default __webpack_public_path__ + "static/media/img6.ad2b6d4f.jpg";